module.exports = __webpack_public_path__ + "img/car.9c63fbe9.svg";